import { render, staticRenderFns } from "./CompareTo.vue?vue&type=template&id=752a761a&scoped=true&"
import script from "./CompareTo.vue?vue&type=script&lang=js&"
export * from "./CompareTo.vue?vue&type=script&lang=js&"
import style0 from "./CompareTo.vue?vue&type=style&index=0&id=752a761a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752a761a",
  null
  
)

export default component.exports